import api from './client';
import { AuthResponse, LoginRequest, ResetPasswordRequest, InvitationPreview } from '../types';

export const authApi = {
  login: (data: LoginRequest) =>
    api.post<AuthResponse>('/api/auth/login', data),

  resetPassword: (data: ResetPasswordRequest) =>
    api.post('/api/auth/reset-password', data),

  forgotPassword: (usernameOrEmail: string) =>
    api.post<{ message: string }>('/api/auth/forgot-password', { usernameOrEmail }),

  resetPasswordWithToken: (token: string, newPassword: string) =>
    api.post<{ message: string }>('/api/auth/reset-password-with-token', { token, newPassword }),

  logout: () =>
    api.post('/api/auth/logout'),

  /** Świeży stan konta (logo/nazwa firmy itd.) do odświeżenia AuthContext bez przelogowania. */
  me: () =>
    api.get<AuthResponse>('/api/auth/me'),

  previewInvitation: (token: string) =>
    api.get<InvitationPreview>(`/api/auth/invitation/${token}`),

  // Loginem zostaje e-mail z zaproszenia — backend ustawia go sam (username ignorowany).
  acceptInvitation: (token: string, data: { username?: string; password: string; firstName?: string; lastName?: string }) =>
    api.post<{ message: string }>(`/api/auth/invitation/${token}/accept`, data),
};
